import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs';
import {WorkVisit} from '../models/workVisit';

@Injectable()
export class AssignmentService {

  constructor(private httpClient: HttpClient) {
  }

  getAssignmentsByClient(clientUniqId: string): Observable<any[]> {
    return this.httpClient.get<any[]>(environment.baseUrlWs + '/api/assignments/' + clientUniqId);
  }

  getAssignment(assignmentId: string): Observable<any> {
    return this.httpClient.get<any>(environment.baseUrlWs + '/api/assignment/' + assignmentId);
  }

  getAssignmentPocs(assignmentId: string): Observable<any> {
    return this.httpClient.get<any>(environment.baseUrlWs + '/api/assignment-pocs/' + assignmentId);
  }

  getXcos(id: string): Observable<WorkVisit[]> {
    return this.httpClient.get<any[]>(environment.baseUrlWs + '/api/assignment-xcos/' + id);
  }

}
